import TriggeredHookContextDecorator from "../../../App/compositions/TriggeredHookContextDecorator";
import useResilientCreateMedicalNonCanContactResult from "../hooks/useResilientCreateMedicalNonCanContactResult";

/** Decorate the {@link useResilientCreateMedicalNonCanContactResult} hook, providing context-aware parameters. */
const ComposedUseCreateMedicalNonCanContactResult = TriggeredHookContextDecorator(
  useResilientCreateMedicalNonCanContactResult,
  ({ contactId, patient, disqualifyingReasonsCState }) => ({
    contactId: contactId,
    patientId: patient.id,
    patientLeadId: patient.lead.id,
    disqualifyingReasons: disqualifyingReasonsCState || []
  })
);

export default ComposedUseCreateMedicalNonCanContactResult;
